// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"1a38937a","211":"5545ee14","280":"229aecd1","453":"90d27115","455":"97bc6436","570":"ddde3ef6","822":"f7a9360f","977":"57b1ebe6"}[chunkId] + ".chunk.js";
};